import BannerComp from "../components/BannerComp";
import CtaComp from "../components/CtaComp";
import PartnerSliderComp from "../components/PartnerSliderComp";
import PricePlanComp from "../components/PricePlanComp";
import Seo from "../components/Seo";
import { plans } from "../data/pricing";
import { createBreadcrumbSchema } from "../lib/seo";
import styles from "./DigitalMarketing.module.css";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";

const seo = {
  title: "Strategic Digital Marketing Services For Healthcare Providers",
  description:
    "Our healthcare team creates custom websites and marketing strategies to boost online presence, attract patients, and grow your practice.",
  keywords:
    "healthcare digital marketing, medical marketing services, healthcare branding, lead generation",
  schema: [
    {
      "@context": "https://schema.org",
      "@type": "Service",
      name: "Digital Marketing Services",
      url: "https://psprcm.us/digital-marketing/",
      description:
        "Our healthcare team creates custom websites and marketing strategies to boost online presence, attract patients, and grow your practice.",
      serviceType: "Digital Marketing",
      provider: {
        "@type": "Organization",
        name: "Physicians Success Partners",
        url: "https://psprcm.us/",
        logo: "https://psprcm.us/logo/main-logo.webp",
        telephone: "+1 6155536787",
        email: "info@psprcm.us",
        address: {
          "@type": "PostalAddress",
          streetAddress: "1616 Westgate Circle",
          addressLocality: "Brentwood",
          addressRegion: "TN",
          postalCode: "37027",
          addressCountry: "USA",
        },
      },
      areaServed: {
        "@type": "Country",
        name: "United States",
      },
      audience: {
        "@type": "MedicalAudience",
        audienceType: "Healthcare Providers",
      },
      availableChannel: {
        "@type": "ServiceChannel",
        serviceLocation: {
          "@type": "Place",
          address: { "@type": "PostalAddress", addressCountry: "USA" },
        },
        availableLanguage: ["English"],
      },
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Digital Marketing Solutions",
        itemListElement: [
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Search Engine Optimization (SEO)" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Pay-Per-Click (PPC) Advertising" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Social Media Management" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Content Marketing & Blogging" } },
          { "@type": "Offer", itemOffered: { "@type": "Service", name: "Online Reputation Management" } },
        ],
      },
    },
    createBreadcrumbSchema("/digital-marketing", "Strategic Digital Marketing Services For Healthcare Providers"),
  ],
};

export default function DigitalMarketing() {
  return (
    <div className={styles.page}>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/digital-marketing"
        schema={seo.schema}
      />
      <BannerComp
        heading="Crafting Digital Solutions That Drive Success"
        paragraph="Our expert team delivers bespoke websites and strategic marketing services designed to enhance your online presence and achieve your business goals."
        btnText="Contact Us"
        btnLink="/contact-us"
        BannerBgImg="/pages-banner.webp"
        BannerColImg="/img/marketing/digital-marketing-img.webp"
        form={false}
      />
      <PartnerSliderComp />
      <Section1 />
      <CtaComp
        heading="We Are on A Mission to Improve Digital Marketing Space."
        description="To leverage over 20 years of expertise in web development, telemarketing, and digital marketing to deliver innovative, customized solutions that drive measurable growth for our clients. We are committed to providing reliable, results-oriented services that empower businesses to succeed in the digital age while ensuring continuous support and staying ahead of industry trends."
      />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <PricePlanComp
        kicker="Pricing Plans"
        title="Affordable Plans for Every Business Stage"
        lead="Select the plan that matches your campaign size, outreach goals, and reporting needs. Every package is crafted to maximize results while staying budget-friendly."
        plans={plans}
      />
    </div>
  );
}
